import { RenderCheckboxInput, RenderTextInput } from "app/common/renderInput";
import { Formik } from "formik";
import moment from "moment";
import Tooltip from "rc-tooltip";
import { Fragment, useEffect } from "react";
import { Button, Col, Collapse, Form, Modal, Row } from "react-bootstrap";
import { FaEdit } from "react-icons/fa";
import { MdCheck, MdClose, MdDelete, MdModeEdit } from "react-icons/md";

const DateModal = ({
  showDateModal,
  handleClose,
  dateModalDetails,
  handleEdit,
  handleDelete,
  rowEdit,
  cancelEdit,
  editingRowId,
  setEditingRowId,
  expandedRowId,
  setExpandedRowId,
  originalRow,
  setOriginalRow,
}) => {
  useEffect(() => {
    if (!showDateModal) {
      setEditingRowId(null);
      setExpandedRowId(null);
    }
  }, [showDateModal]);

  const startEdit = (item) => {
    setEditingRowId(item.id);
    setExpandedRowId(item.id);
    setOriginalRow({ ...item });
  };
  const isRowChanged = (values) => {
    debugger;
    return JSON.stringify(values) !== JSON.stringify(originalRow);
  };
  return (
    <Modal show={showDateModal} size="xl" centered scrollable>
      <Modal.Header className="bg-primary">
        <Modal.Title style={{ color: "white" }}>Flight Dates</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div
          style={{
            backgroundColor: "#f8f9fa",
            padding: "0.2rem 0.2rem",
            borderRadius: "8px",
            marginBottom: "5px",
            border: "1px solid #e9ecef",
          }}
        >
          <h5
            style={{
              fontSize: "1.1rem",
              fontWeight: "700",
              color: "#495057",
              paddingTop: 2,
            }}
          >
            <span style={{ color: "#667eea" }}>
              {dateModalDetails?.airportDeparture?.cityCode}
            </span>
            <span style={{ color: "#6c757d" }}> → </span>
            <span style={{ color: "#764ba2" }}>
              {dateModalDetails?.airportDestination?.cityCode}
            </span>
            <span
              style={{
                fontSize: "0.9rem",
                color: "#6c757d",
                fontWeight: "500",
              }}
            >
              {" "}
              ({dateModalDetails?.tripType})
            </span>
          </h5>
        </div>
        <div style={{ overflowX: "auto" }}>
          <table className="table table-hover">
            <thead>
              <tr
                className="bg-primary"
                style={{
                  backgroundColor: "#f8f9fa",
                  borderBottom: "2px solid #dee2e6",
                  color: "white",
                }}
              >
                <th
                  style={{
                    padding: "2px",
                    fontWeight: "600",

                    fontSize: "0.9rem",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    textAlign: "center",
                  }}
                >
                  Date
                </th>
                <th
                  style={{
                    padding: "2px",
                    fontWeight: "600",

                    fontSize: "0.9rem",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    textAlign: "center",
                  }}
                >
                  Departure
                </th>
                <th
                  style={{
                    padding: "2px",
                    fontWeight: "600",

                    fontSize: "0.9rem",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    textAlign: "center",
                  }}
                >
                  Arrival
                </th>
                <th
                  style={{
                    padding: "2px",
                    fontWeight: "600",

                    fontSize: "0.9rem",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    textAlign: "center",
                  }}
                >
                  Seats
                </th>
                <th
                  style={{
                    padding: "2px",
                    fontWeight: "600",

                    fontSize: "0.9rem",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    textAlign: "center",
                  }}
                >
                  PNR
                </th>
                <th
                  style={{
                    padding: "2px",
                    fontWeight: "600",

                    fontSize: "0.9rem",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    textAlign: "center",
                  }}
                >
                  Actions
                </th>
              </tr>
            </thead>

            <tbody>
              {dateModalDetails?.charterFlights?.map((item) => {
                const isEditing = editingRowId === item.id;
                const isExpanded = expandedRowId === item.id;

                return (
                  <Formik
                    key={item.id}
                    enableReinitialize
                    initialValues={
                      item
                      //   {
                      //   flightDate: item.flightDate?.split("T")[0],
                      //   departureTime: item.departureTime,
                      //   arrivalTime: item.arrivalTime,
                      //   seat: item.seat,
                      //   pnr: item.pnr,
                      //   isActive: item.isActive,
                      //   refundable: item.refundable,
                      //   adultBaseFare: item.adultBaseFare,
                      //   adultTotalTaxPerSeat: item.adultTotalTaxPerSeat,
                      //   childBaseFare: item.childBaseFare,
                      //   childTotalTaxPerSeat: item.childTotalTaxPerSeat,
                      //   infrantBaseFare: item.infrantBaseFare,
                      //   infrantTotalTaxPerSeat: item.infrantTotalTaxPerSeat,
                      // }
                    }
                    onSubmit={(values) => {
                      !isRowChanged(values)
                        ? cancelEdit()
                        : rowEdit({ ...item, ...values });

                      setEditingRowId(null);
                      setExpandedRowId(null);
                    }}
                  >
                    {({
                      values,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      setFieldValue,
                      resetForm,
                    }) => (
                      <>
                        {/* MAIN ROW */}
                        <tr
                          style={{
                            backgroundColor: isEditing ? "#fff3cd" : "white",
                          }}
                        >
                          <td
                            style={{
                              padding: "4px",
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            {isEditing ? (
                              <Form.Control
                                type="date"
                                name="flightDate"
                                value={values.flightDate?.split("T")[0]}
                                onChange={handleChange}
                              />
                            ) : (
                              moment(item.flightDate).format("DD/MM/YYYY")
                            )}
                          </td>

                          <td
                            style={{
                              padding: "4px",
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            {isEditing ? (
                              <Form.Control
                                type="time"
                                name="departureTime"
                                value={values.departureTime}
                                onChange={handleChange}
                              />
                            ) : (
                              moment(values.departureTime, "HH:mm").format(
                                "HH:mm",
                              )
                            )}
                          </td>

                          <td
                            style={{
                              padding: "4px",
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            {isEditing ? (
                              <Form.Control
                                type="time"
                                name="arrivalTime"
                                value={values.arrivalTime}
                                onChange={handleChange}
                              />
                            ) : (
                              moment(values.arrivalTime, "HH:mm").format(
                                "HH:mm",
                              )
                            )}
                          </td>

                          <td
                            style={{
                              padding: "4px",
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            {isEditing ? (
                              <Form.Control
                                type="number"
                                name="seat"
                                value={values.seat}
                                onChange={handleChange}
                              />
                            ) : (
                              item.seat
                            )}
                          </td>

                          <td
                            style={{
                              padding: "4px",
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            {isEditing ? (
                              <Form.Control
                                type="text"
                                name="pnr"
                                value={values.pnr}
                                onChange={handleChange}
                              />
                            ) : (
                              item.pnr
                            )}
                          </td>

                          <td
                            style={{
                              padding: "4px",
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            {isEditing ? (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  gap: "0.75rem",
                                }}
                              >
                                <button
                                  type="submit"
                                  onClick={handleSubmit}
                                  className="btn btn-success btn-sm me-2"
                                  style={{
                                    background: "#28a745",
                                    border: "none",
                                    borderRadius: "6px",
                                    padding: "0.5rem 0.75rem",
                                    cursor: "pointer",
                                    transition: "all 0.2s ease",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                  onMouseOver={(e) =>
                                    (e.currentTarget.style.background =
                                      "#218838")
                                  }
                                  onMouseOut={(e) =>
                                    (e.currentTarget.style.background =
                                      "#28a745")
                                  }
                                >
                                  <MdCheck color="white" />
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm"
                                  onClick={() => {
                                    resetForm();
                                    cancelEdit();
                                    setEditingRowId(null);
                                    setExpandedRowId(null);
                                  }}
                                  style={{
                                    background: "#dc3545",
                                    border: "none",
                                    borderRadius: "6px",
                                    padding: "0.5rem 0.75rem",
                                    cursor: "pointer",
                                    transition: "all 0.2s ease",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                  onMouseOver={(e) =>
                                    (e.currentTarget.style.background =
                                      "#c82333")
                                  }
                                  onMouseOut={(e) =>
                                    (e.currentTarget.style.background =
                                      "#dc3545")
                                  }
                                >
                                  <MdClose color="white" />
                                </button>
                              </div>
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  gap: "0.5rem",
                                }}
                              >
                                <Tooltip overlay="Quick Edit">
                                  <button
                                    className="btn btn-outline-success btn-sm me-2"
                                    onClick={() => startEdit(item)}
                                    // onClick={() => {
                                    //   startEdit(item);
                                    //   toggleExpand(item.id);
                                    // }}
                                    style={{
                                      background: "transparent",
                                      border: "1px solid #28a745",
                                      borderRadius: "6px",
                                      padding: "0.4rem",
                                      cursor: "pointer",
                                      transition: "all 0.2s ease",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                    onMouseOver={(e) => {
                                      e.currentTarget.style.background =
                                        "#28a745";
                                      e.currentTarget.querySelector(
                                        "svg",
                                      ).style.color = "white";
                                    }}
                                    onMouseOut={(e) => {
                                      e.currentTarget.style.background =
                                        "transparent";
                                      e.currentTarget.querySelector(
                                        "svg",
                                      ).style.color = "#28a745";
                                    }}
                                  >
                                    <MdModeEdit />
                                  </button>
                                </Tooltip>

                                {/* <Tooltip overlay="Edit Details">
                                  <button
                                    className="btn btn-outline-primary btn-sm me-2"
                                    onClick={() =>
                                      handleEdit(item.flightDate.split("T")[0])
                                    }
                                    style={{
                                      background: "transparent",
                                      border: "1px solid #667eea",
                                      borderRadius: "6px",
                                      padding: "0.4rem",
                                      cursor: "pointer",
                                      transition: "all 0.2s ease",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                    onMouseOver={(e) => {
                                      e.currentTarget.style.background =
                                        "#667eea";
                                      e.currentTarget.querySelector(
                                        "svg",
                                      ).style.color = "white";
                                    }}
                                    onMouseOut={(e) => {
                                      e.currentTarget.style.background =
                                        "transparent";
                                      e.currentTarget.querySelector(
                                        "svg",
                                      ).style.color = "#667eea";
                                    }}
                                  >
                                    <FaEdit />
                                  </button>
                                </Tooltip> */}

                                <Tooltip overlay="Delete">
                                  <button
                                    className="btn btn-outline-danger btn-sm"
                                    onClick={() => handleDelete(item.id)}
                                    style={{
                                      background: "transparent",
                                      border: "1px solid #dc3545",
                                      borderRadius: "6px",
                                      padding: "0.4rem",
                                      cursor: "pointer",
                                      transition: "all 0.2s ease",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                    onMouseOver={(e) => {
                                      e.currentTarget.style.background =
                                        "#dc3545";
                                      e.currentTarget.querySelector(
                                        "svg",
                                      ).style.color = "white";
                                    }}
                                    onMouseOut={(e) => {
                                      e.currentTarget.style.background =
                                        "transparent";
                                      e.currentTarget.querySelector(
                                        "svg",
                                      ).style.color = "#dc3545";
                                    }}
                                  >
                                    <MdDelete />
                                  </button>
                                </Tooltip>
                              </div>
                            )}
                          </td>
                        </tr>

                        {/* EXPANDED ROW */}
                        <tr>
                          <td colSpan={12}>
                            <Collapse in={isExpanded}>
                              <div>
                                <Row>
                                  <RenderCheckboxInput
                                    type="switch"
                                    name="isActive"
                                    display="Active"
                                    value={values.isActive}
                                    onChange={(e) =>
                                      setFieldValue(
                                        "isActive",
                                        e.target.checked,
                                      )
                                    }
                                  />

                                  <RenderCheckboxInput
                                    type="switch"
                                    name="refundable"
                                    display="Refundable"
                                    value={values.refundable}
                                    onChange={(e) =>
                                      setFieldValue(
                                        "refundable",
                                        e.target.checked,
                                      )
                                    }
                                  />
                                </Row>

                                <h6>Adult Fare</h6>
                                <Row>
                                  <Col md={4}>
                                    <RenderTextInput
                                      name="adultBaseFare"
                                      type="number"
                                      value={values.adultBaseFare}
                                      onChange={handleChange}
                                    />
                                  </Col>
                                  <Col md={4}>
                                    <RenderTextInput
                                      name="adultTotalTaxPerSeat"
                                      type="number"
                                      value={values.adultTotalTaxPerSeat}
                                      onChange={handleChange}
                                    />
                                  </Col>
                                  <Col md={4}>
                                    <RenderTextInput
                                      readOnly
                                      value={
                                        values.adultBaseFare +
                                        values.adultTotalTaxPerSeat
                                      }
                                    />
                                  </Col>
                                </Row>

                                <h6>Child Fare (Per Seat)</h6>
                                <Row className="form-row">
                                  <Col xs={12} md={4}>
                                    <RenderTextInput
                                      type="number"
                                      display="Total Base Fare"
                                      name="childBaseFare"
                                      value={values.childBaseFare}
                                      onChange={handleChange}
                                      required
                                      placeholder="Total Base Fare"
                                    />
                                  </Col>
                                  <Col xs={12} md={4}>
                                    <RenderTextInput
                                      type="number"
                                      display="Total Tax"
                                      name="childTotalTaxPerSeat"
                                      value={values.childTotalTaxPerSeat}
                                      onChange={handleChange}
                                      required
                                      placeholder="Total Tax"
                                    />
                                  </Col>
                                  <Col xs={12} md={4}>
                                    <RenderTextInput
                                      type="number"
                                      display="Total Fare (Base Fare +Tax)"
                                      value={
                                        values.childTotalTaxPerSeat +
                                        values.childBaseFare
                                      }
                                      readOnly
                                    />
                                  </Col>
                                </Row>

                                {/* Infant Fare */}
                                <h6>Infant Fare (Per Seat)</h6>
                                <Row className="form-row">
                                  <Col xs={12} md={4}>
                                    <RenderTextInput
                                      type="number"
                                      display="Total Base Fare"
                                      name="infrantBaseFare"
                                      value={values.infrantBaseFare}
                                      onChange={handleChange}
                                      required
                                      placeholder="Total Base Fare"
                                    />
                                  </Col>
                                  <Col xs={12} md={4}>
                                    <RenderTextInput
                                      type="number"
                                      display="Total Tax"
                                      name="infrantTotalTaxPerSeat"
                                      value={values.infrantTotalTaxPerSeat}
                                      onChange={handleChange}
                                      required
                                      placeholder="Total Tax"
                                    />
                                  </Col>
                                  <Col xs={12} md={4}>
                                    <RenderTextInput
                                      type="number"
                                      display="Total Fare (Base Fare +Tax)"
                                      value={
                                        values.infrantTotalTaxPerSeat +
                                        values.infrantBaseFare
                                      }
                                      readOnly
                                    />
                                  </Col>
                                </Row>
                              </div>
                            </Collapse>
                          </td>
                        </tr>
                      </>
                    )}
                  </Formik>
                );
              })}
            </tbody>
          </table>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DateModal;
